import { defaultTheme, Theme } from '@amzn/storm-ui';
import { VIEW_TYPE } from 'src/app/slice';
import { squidInk } from 'src/colors';

export interface StyledComponentsPropWithTheme {
  theme: ThemeStyles;
}

export interface ThemeStyles extends Theme {
  header: {
    contextBar: {
      background: string;
      foreground: string;
      pageLayoutType: {
        INTERNAL_STANDARD: {
          background: string;
        };
        FOCUS: {
          background: string;
          foreground: string;
        };
      };
    };
    utility: {
      icon: {
        background: string;
        backgroundHover: string;
        foreground: string;
        foregroundHover: string;
      };
    };
    breadcrumb: {
      foreground?: string;
    };
    sectionNav: {
      background: string;
    };
    pageHeader: {
      background: string;
    };
  };
  nav: {
    link: {
      color: string;
      textDecoration: string;
    };
    text: {
      color: string;
    };
    overlay: {
      background: string;
    };
  };
  pivotNav: {
    background?: string;
    buttonBackgroundHover?: string;
    buttonBackgroundActive?: string;
  };
}

export const getExtendedTheme = (viewType: VIEW_TYPE): ThemeStyles => {
  if (viewType === VIEW_TYPE.MOBILE) {
    return {
      ...defaultTheme,
      header: {
        contextBar: {
          background: squidInk,
          foreground: defaultTheme.color.gray[0],
          pageLayoutType: {
            INTERNAL_STANDARD: {
              background: defaultTheme.color.lightBlue[900],
            },
            FOCUS: {
              background: defaultTheme.color.gray[0],
              foreground: defaultTheme.text.color.default,
            },
          },
        },
        utility: {
          icon: {
            background: 'transparent',
            backgroundHover: defaultTheme.color.gray[1000],
            foreground: defaultTheme.text.color.inverted,
            foregroundHover: defaultTheme.text.color.inverted,
          },
        },
        breadcrumb: {
          foreground: defaultTheme.color.gray[800],
        },
        sectionNav: {
          background: defaultTheme.color.gray[0],
        },
        pageHeader: {
          background: defaultTheme.color.gray[0],
        },
      },
      nav: {
        link: {
          color: defaultTheme.color.gray[50],
          textDecoration: 'none',
        },
        text: {
          color: defaultTheme.color.gray[900],
        },
        overlay: {
          background: squidInk,
        },
      },
      pivotNav: {},
    };
  }
  return {
    ...defaultTheme,
    header: {
      contextBar: {
        background: squidInk,
        foreground: defaultTheme.color.gray[0],
        pageLayoutType: {
          INTERNAL_STANDARD: {
            background: defaultTheme.color.lightBlue[900],
          },
          FOCUS: {
            background: defaultTheme.color.gray[0],
            foreground: defaultTheme.text.color.default,
          },
        },
      },
      utility: {
        icon: {
          background: 'transparent',
          backgroundHover: defaultTheme.color.gray[1000],
          foreground: defaultTheme.text.color.inverted,
          foregroundHover: defaultTheme.text.color.inverted,
        },
      },
      breadcrumb: {
        foreground: defaultTheme.color.gray[0],
      },
      sectionNav: {
        background: defaultTheme.color.gray[0],
      },
      pageHeader: {
        background: defaultTheme.color.gray[0],
      },
    },
    nav: {
      link: {
        color: defaultTheme.color.gray[900],
        textDecoration: 'none',
      },
      text: {
        color: defaultTheme.color.gray[900],
      },
      overlay: {
        background: squidInk,
      },
    },
    pivotNav: {
      background: defaultTheme.color.gray[0],
      buttonBackgroundHover: defaultTheme.color.gray[100],
      buttonBackgroundActive: defaultTheme.color.gray[100],
    },
  };
};
